import classNames from 'classnames';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useState } from 'react';
import { getCartProductNumber } from '../common';

export interface EcoCartIconLProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * iconUrl
     */
    iconUrl?: string;
}
/**
 * 维护:谢保林
 *
 * 购物车
 */
const EcoCartIconL: React.FC<EcoCartIconLProps> = ({ className, iconUrl }) => {
    const prefixCls = `eco-cart-icon-l`;
    const classes = classNames(prefixCls, 'GtmModuleData-btn-common', {
        [`${className}`]: className,
    });
    const [totalA, setTotalA] = useState(0);
    const openHandle = () => {
        EcoDesignEventsBus.emit('eco-cart-open');
        gtm.push({
            __bth_only_ef: true,
            event: 'uaEvent',
            event_name: 'floating_button',
            button_name: 'widgets-cart-open',
            __btn_type: 'common',
            __btn_id1: prefixCls,
            __btn_id2: 'widgets-cart',
        });
    };
    useEffect(() => {
        // 数量变化了
        EcoDesignEventsBus.on('eco-cart-change', (items: any[]) => {
            const items2 = JSON.parse(JSON.stringify(items));
            const totalA = getCartProductNumber(items2);
            setTotalA(totalA);
        });
    }, []);
    return (
        <div className={classes} onClick={openHandle} data-btn-id="widgets-cart">
            {iconUrl ? (
                <EcoImg pc={iconUrl} className={`${prefixCls}-custom-img`}></EcoImg>
            ) : (
                <div className={`${prefixCls}-img`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4.88086 2.87939H18.247C18.939 2.87939 19.5 3.44036 19.5 4.13236C19.5 4.25079 19.4832 4.36863 19.4501 4.48235L17.4454 11.3736C17.2897 11.9087 16.7995 12.2766 16.2423 12.2766H8.555C7.9978 12.2766 7.50755 11.9087 7.35191 11.3736L4.88086 2.87939Z"
                            stroke="#010101"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                        />
                        <path
                            d="M5.25889 4.1324L4.55622 1.87984C4.39295 1.35645 3.90836 1 3.3601 1H1.5"
                            stroke="#010101"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                        />
                        <path
                            d="M8.5 16C9.05228 16 9.5 15.5523 9.5 15C9.5 14.4477 9.05228 14 8.5 14C7.94772 14 7.5 14.4477 7.5 15C7.5 15.5523 7.94772 16 8.5 16Z"
                            fill="#010101"
                        />
                        <path
                            d="M16.5 16C17.0523 16 17.5 15.5523 17.5 15C17.5 14.4477 17.0523 14 16.5 14C15.9477 14 15.5 14.4477 15.5 15C15.5 15.5523 15.9477 16 16.5 16Z"
                            fill="#010101"
                        />
                        <path d="M9.89258 6.02332V9.15812" stroke="#010101" strokeWidth="1.2" strokeLinecap="round" />
                        <path d="M12.3984 6.02332V9.15812" stroke="#010101" strokeWidth="1.2" strokeLinecap="round" />
                        <path d="M14.9048 6.02332V9.15812" stroke="#010101" strokeWidth="1.2" strokeLinecap="round" />
                    </svg>
                </div>
            )}

            {!!totalA && <div className={`${prefixCls}-num ${totalA > 99 ? `${prefixCls}-num-99` : ''}`}>{totalA > 99 ? '' : totalA}</div>}
        </div>
    );
};

export default EcoCartIconL;
